// extracted by mini-css-extract-plugin
export default {"profileNavLinks":"NavList_profileNavLinks__kqcvm","active":"NavList_active__AMcQj"};